<template>
  <div class="side-menu">
    <div class="box">
      <div class="tip-text color-Gray_9e" v-if="descStr">
        {{ descStr }}
      </div>
      <ul>
        <li
          v-for="(item, index) in itemList"
          :key="index"
          @click="selectItem(item)"
          :class="{ active: activeItem.id == item.id }"
        >
          <span class="icon-left">
            <svg-icon
              :icon-class="item.icon ? 'button_' + item.icon : 'button_icon-01'"
              :style="item.color === '#f5f7fa' ? 'color:#313132' : 'color:' + item.color"
            ></svg-icon>
          </span>
          <span class="name" v-tip>{{ item.name }}</span>
          <span class="icon-right">
            <i class="el-icon-delete-solid" @click.stop="deleteItem(item)"></i>
          </span>
        </li>
        <li class="add-btn" @click="addItem">
          <span class="icon">
            <i class="el-icon-plus"></i>
          </span>
          添加
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/common"

export default {
  name: "side-menu",
  props: {
    descStr: String,
    itemList: Array,
    activeItem: Object
  },
  methods: {
    selectItem(info) {
      this.$emit("select", info)
    },
    addItem() {
      this.$emit("create")
    },
    deleteItem(info) {
      this.$emit("delete", info)
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  .box {
    background: #fff;
    .tip-text {
      padding: 14px 24px;
      font-size: 14px;
    }
  }
  ul {
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    color: #555;
    li {
      height: 56px;
      padding: 0 24px;
      line-height: 56px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      border-top: 1px solid #eeeeee;
      &.active {
        background-color: #f9f9f9;
      }
      &:hover {
        background-color: #f9f9f9;
        .icon-right {
          display: block;
        }
      }
      .name {
        flex: 1 1;
      }
      .icon-left {
        margin-right: 10px;
      }
      .el-icon-plus {
        margin-right: 10px;
      }
      .el-icon-delete-solid {
        padding: 3px;
        color: #555;
        &:hover {
          color: #f44336;
        }
      }
    }
  }
}
</style>
